import { useEffect } from "react";
import { usePatchPortfolioCommoditiesMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioCommoditiesMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { getCommoditiesFormSchema } from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormSchema";
import { mapPortfolioToCommoditiesForm } from "web_myplann/Portfolio/Forms/CommoditiesForm/mapPortfolioToCommoditiesForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditCommoditiesFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditCommoditiesForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditCommoditiesFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } =
		usePatchPortfolioCommoditiesMutation(portfolioId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getCommoditiesFormSchema(t),
		defaultValues: mapPortfolioToCommoditiesForm(portfolio),
		mutate,
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
